export interface AppConfig {
  appId?: string;
  assets?: {
    additionalEnabled?: string[];
  };
  domains?: string[];
  features?: {
    fiat?: boolean;
    swaps?: boolean;
    collectibles?: boolean;
  };
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

export function getAppConfig(): AppConfig {
  return window.__APP_CONFIG__ ?? {};
}

export function getAppId(): string {
  const { appId } = getAppConfig();

  return `passkeys${appId ? `/${appId}` : ''}`;
}

export function getIsFeatureEnabled(
  feature: 'collectibles' | 'fiat' | 'swaps',
) {
  const { features } = getAppConfig();

  if (!features) {
    return true;
  }

  const featureConfig = features[feature];
  if (featureConfig === undefined) {
    return true;
  }

  if (featureConfig !== false) {
    return true;
  }

  return false;
}
